import { handleMaintenance } from './handleMaintenance.js'
import { createHttpClient } from './httpClient.js'

export const PublicApiClient = createHttpClient({
  baseURL: import.meta.env.VITE_BACKEND_PUBLIC_URL,
  errorInterceptor: error => {
    if (error.response?.status === 503) {
      handleMaintenance()
    }

    throw error
  }
})
